import { getTasks, getDayData, saveDayData, calcPercent, formatDate } from '../storage.js';
import { CATEGORIES } from '../tasks.js';
import { shareDay } from './ShareCard.js';

const accordionState = {};

function greeting() {
  const h = new Date().getHours();
  if (h < 12) return 'Доброго ранку';
  if (h < 17) return 'Доброго дня';
  return 'Доброго вечора';
}

function dateLabel() {
  return new Date().toLocaleDateString('uk-UA', {
    weekday: 'long', day: 'numeric', month: 'long',
  }).replace(/^./, c => c.toUpperCase());
}

function checkmarkSVG() {
  return `<svg width="11" height="8" viewBox="0 0 11 8" fill="none">
    <path d="M1 4L4 7L10 1" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`;
}

function chevronSVG() {
  return `<svg class="chevron" width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path d="M2.5 5L7 9.5L11.5 5" stroke="var(--text-light)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`;
}

function buildTaskCard(task, done) {
  return `
    <div class="task-card ${done ? 'done' : ''}" data-task-id="${task.id}">
      <div class="checkbox ${done ? 'checked' : ''}">${done ? checkmarkSVG() : ''}</div>
      <span class="task-label">${task.label}</span>
    </div>`;
}

function buildAccordion(catKey, tasks, dayData) {
  const cat   = CATEGORIES[catKey];
  const done  = tasks.filter(t => !!dayData[t.id]).length;
  const isOpen = accordionState[catKey] !== false;
  if (!(catKey in accordionState)) accordionState[catKey] = true;

  return `
    <div class="accordion ${isOpen ? 'open' : ''}" data-cat="${catKey}">
      <div class="accordion-header">
        <div class="cat-bar" style="background:${cat.hex}"></div>
        <span class="cat-name">${cat.label}</span>
        <span class="cat-count">${done}/${tasks.length}</span>
        ${chevronSVG()}
      </div>
      <div class="accordion-body ${isOpen ? '' : 'collapsed'}">
        ${tasks.map(t => buildTaskCard(t, !!dayData[t.id])).join('')}
      </div>
    </div>`;
}

function buildView(tasks, dayData) {
  const pct   = calcPercent(tasks, dayData);
  const done  = tasks.filter(t => !!dayData[t.id]).length;
  const total = tasks.length;

  const grouped = {};
  tasks.forEach(t => {
    if (!grouped[t.category]) grouped[t.category] = [];
    grouped[t.category].push(t);
  });

  const completeBanner = done === total
    ? `<p class="progress-complete">Ти виконала все сьогодні ✦</p>` : '';

  const accordions = Object.entries(grouped)
    .map(([cat, list]) => buildAccordion(cat, list, dayData))
    .join('');

  return `
    <div class="view">
      <div class="view-header">
        <p class="view-eyebrow">${greeting()}</p>
        <h1 class="view-title">${dateLabel()}</h1>
      </div>

      <div class="card progress-card">
        <div class="progress-header">
          <span class="progress-label">Прогрес сьогодні</span>
          <span class="progress-count">${done} з ${total} виконано</span>
        </div>
        <div class="progress-track">
          <div class="progress-fill" style="width:${pct}%"></div>
        </div>
        ${completeBanner}
      </div>

      ${accordions}

      <button class="share-btn">Поділитися днем</button>
    </div>`;
}

let _container = null;

function rerender() {
  if (!_container) return;
  const tasks   = getTasks();
  const today   = formatDate();
  const dayData = getDayData(today);
  _container.innerHTML = buildView(tasks, dayData);
  attachEvents();
}

function attachEvents() {
  if (!_container) return;

  // Accordion toggle
  _container.querySelectorAll('.accordion-header').forEach(header => {
    header.addEventListener('click', () => {
      const acc = header.closest('.accordion');
      const cat = acc.dataset.cat;
      accordionState[cat] = !accordionState[cat];
      acc.classList.toggle('open', accordionState[cat]);
      acc.querySelector('.accordion-body').classList.toggle('collapsed', !accordionState[cat]);
    });
  });

  // Task toggle (event delegation on each accordion body)
  _container.querySelectorAll('.task-card').forEach(card => {
    card.addEventListener('click', () => {
      const id    = card.dataset.taskId;
      const today = formatDate();
      const data  = getDayData(today);
      saveDayData(today, id, !data[id]);
      rerender();
    });
  });

  // Share
  _container.querySelector('.share-btn')?.addEventListener('click', () => {
    const tasks   = getTasks();
    const today   = formatDate();
    const dayData = getDayData(today);
    shareDay(tasks, dayData);
  });
}

export function render(container) {
  _container = container;
  rerender();
}
